import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useBatteryStore = defineStore('battery', () => {
    // 마지막으로 확인된 충전 상태를 전역적으로 유지 (초기값 0)
    const chargeStatus = ref(0)
    const batteryPercent = ref(0)

    function setBatteryInfo(status, percent) {
        chargeStatus.value = status
        batteryPercent.value = percent
    }

    return { chargeStatus, batteryPercent, setBatteryInfo }
})